import { Box, useMediaQuery } from '@mui/material';
import { useThemeContext } from '../../../theme/ThemeContextProvider';
import StepHeader from './StepHeader';
import CustomButton from '../../MUIComponents/CustomButton';
import RightArrowIcon from '../../Icons/RightArrowIcon';
import React, { FC, PropsWithChildren } from 'react';
import LeftArrowIcon from '../../Icons/LeftArrowIcon';
import {
  ButtonIconPositionEnum,
  ButtonTypeEnum,
} from '../../../enums/button-type-enum';
import { useSelector } from 'react-redux';
import { selectAuthData } from '../../../store/selectors/authSelector';
import { UserRoleEnum } from '../../../enums/user-data-field-enum';

interface IStepFormProps {
  onNext: () => void;
  onSkip?: () => void;
  setStep: (_: number) => void;
  nextDisabled?: boolean;
  backDisabled?: boolean;
  skipDisabled?: boolean;
  step: number;
  title: string | React.ReactNode;
  needBackButton?: boolean;
}

const StepForm: FC<PropsWithChildren<IStepFormProps>> = ({
  onNext,
  onSkip,
  setStep,
  nextDisabled = false,
  backDisabled = false,
  skipDisabled = false,
  step,
  children,
  title,
  needBackButton = true,
}) => {
  const { theme } = useThemeContext();
  const mobileView = useMediaQuery(theme.breakpoints.down('md'));

  const authData = useSelector(selectAuthData);
  const role = authData?.user?.role;

  return (
    <Box
      width={'100%'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      gap={mobileView ? '2.25rem' : '3rem'}
    >
      <Box
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        padding={mobileView ? '2.25rem 1rem' : '2.25rem 2.25rem 3rem 2.25rem'}
        gap={'2.25rem'}
        bgcolor={'background.white'}
      >
        <StepHeader step={`STEP 0${step}`} title={title} />
        {children}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '1rem',
          p: mobileView ? '0 1rem' : '0',
        }}
      >
        {onSkip && mobileView && (
          <CustomButton
            variantType={ButtonTypeEnum.SECONDARY}
            buttonWidth="100%"
            onClick={onSkip}
            disabled={skipDisabled}
          >
            skip
          </CustomButton>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent:
              step === 1 || !needBackButton ? 'right' : 'space-between',
            width: '100%',
            gap: mobileView ? '1rem' : '2.25rem',
          }}
        >
          {step > 1 && needBackButton && (
            <CustomButton
              icon={<LeftArrowIcon />}
              variantType={ButtonTypeEnum.SECONDARY}
              buttonWidth="100%"
              onClick={() => setStep(step - 1)}
              iconPosition={ButtonIconPositionEnum.LEFT}
              disabled={backDisabled}
              sx={{ maxWidth: '220px' }}
            >
              Back
            </CustomButton>
          )}

          {onSkip && !mobileView && (
            <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
              <CustomButton
                variantType={ButtonTypeEnum.SECONDARY}
                buttonWidth="220px"
                onClick={onSkip}
                disabled={skipDisabled}
              >
                skip
              </CustomButton>
            </Box>
          )}

          <CustomButton
            type="submit"
            icon={<RightArrowIcon />}
            buttonWidth="100%"
            onClick={onNext}
            disabled={nextDisabled}
            sx={{ maxWidth: '220px' }}
          >
            {step === 4 || (role === UserRoleEnum.AGENT && step === 2)
              ? 'Save'
              : 'next'}
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
};

export default StepForm;
